import { render, staticRenderFns } from "./site-agreement.vue?vue&type=template&id=5b850c3d&scoped=true&"
import script from "./site-agreement.vue?vue&type=script&lang=js&"
export * from "./site-agreement.vue?vue&type=script&lang=js&"
import style0 from "./site-agreement.vue?vue&type=style&index=0&id=5b850c3d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b850c3d",
  null
  
)

export default component.exports